import i18n from 'simple-react-i18n'
import { RESEARCH_TYPE } from '../quality/constants/QualityConstants'

const getStateLabels = () => ({
    0: { value: `[0] ${i18n.unknown}`, classNameColor: 'white', color: 'white' },
    1: { value: `[1] ${i18n.veryGood}`, classNameColor: 'blue', color: 'blue', fontColor: 'white' },
    2: { value: `[2] ${i18n.good}`, classNameColor: 'green', color: 'green', fontColor: 'white' },
    3: { value: `[3] ${i18n.medium}`, classNameColor: 'yellow', color: 'yellow' },
    4: { value: `[4] ${i18n.poorState}`, classNameColor: 'orange', color: 'orange', fontColor: 'white' },
    5: { value: `[5] ${i18n.badState}`, classNameColor: 'red', color: 'red', fontColor: 'white' },
})

const getChimStateLabels = () => ({
    0: { value: `[0] ${i18n.unknown}`, classNameColor: 'white', color: 'white' },
    2: { value: `[2] ${i18n.good}`, classNameColor: 'blue', color: 'blue' },
    5: { value: `[5] ${i18n.badState}`, classNameColor: 'red', color: 'red' },
})

const getStateLabelsNoCode = () => ({
    0: { value: i18n.unknown, classNameColor: 'white', color: 'white' },
    1: { value: i18n.veryGood, classNameColor: 'blue', color: 'blue', fontColor: 'white' },
    2: { value: i18n.good, classNameColor: 'green', color: 'green', fontColor: 'white' },
    3: { value: i18n.medium, classNameColor: 'yellow', color: 'yellow' },
    4: { value: i18n.poorState, classNameColor: 'orange', color: 'orange', fontColor: 'white' },
    5: { value: i18n.badState, classNameColor: 'red', color: 'red', fontColor: 'white' },
})

const VERYGOOD = 1
const GOOD = 2
const CHIM_STATE = 16

const getStatuses = () => [
    { code: 1, name: 'Brute' },
    { code: 2, name: 'Contrôlée niveau 1' },
    { code: 3, name: 'Contrôlée niveau 2' },
    { code: 4, name: 'Interprétée' },
]

const BRUT = 1

const getStatusesWithNoStatus = () => [
    { code: BRUT, name: 'Brute' },
    { code: 2, name: 'Contrôlée niveau 1' },
    { code: 3, name: 'Contrôlée niveau 2' },
    { code: 4, name: 'Interprétée' },
    { code: -1, name: 'Sans statut' },
]

const getShortStatuses = () => [
    { code: BRUT, name: 'Brute' },
    { code: 2, name: 'N1' },
    { code: 3, name: 'N2' },
    { code: 4, name: 'Interprétée' },
]

const UNQUALIFIED = 4

const getQualifications = () => [
    { code: 1, name: 'Correcte' },
    { code: 2, name: 'Incorrecte' },
    { code: 3, name: 'Incertaine' },
    { code: UNQUALIFIED, name: 'Non qualifié' },
]

const getResearchTypes = () => [
    { value: RESEARCH_TYPE.WATER, label: i18n.waterReaserchType },
    { value: RESEARCH_TYPE.INDICES, label: i18n.indices },
    { value: RESEARCH_TYPE.STATES, label: i18n.states },
    { value: RESEARCH_TYPE.TAXON, label: i18n.taxons },
]

const filterOperationFiles = (refLabo = '', files = []) => {
    const labelsMatch = refLabo.toLowerCase().split(/[-,._]/g).map(s => s.replace(/^[0]*/g, ''))
    return files.filter(f => {
        const name = f.name.toLowerCase().split(/[-,._]/g).map(s => s.replace(/^[0]*/g, ' ')).join('')
        return labelsMatch.some(l => name.includes(l))
    })
}

const blankToUndefined = v => (typeof v === 'string' && v.trim() === '' ? undefined : v)

export {
    getStateLabels,
    getStatuses,
    getShortStatuses,
    getQualifications,
    getStatusesWithNoStatus,
    filterOperationFiles,
    getResearchTypes,
    UNQUALIFIED,
    BRUT,
    VERYGOOD,
    GOOD,
    CHIM_STATE,
    getChimStateLabels,
    getStateLabelsNoCode,
    blankToUndefined,
}
